import React, { memo, useMemo } from 'react'
import { Chip } from 'src/components/shared/Chip'
import { colors } from 'src/theme'
import tw from 'twin.macro'

interface Props {
  vinVerified?: boolean
}

const ContractorVINStatusChipComponent = ({ vinVerified }: Props) => {
  const params = useMemo(
    () =>
      vinVerified
        ? {
            color: colors.COLORS_GREEN_500,
            text: 'Verified',
            bgStyle: tw`bg-[rgba(230, 249, 233, 1)]`,
          }
        : {
            color: colors.COLORS_ORANGE_500,
            text: 'Not verified',
            bgStyle: tw`bg-[rgba(255, 238, 214, 1)]`,
          },
    [vinVerified],
  )

  return <Chip className={params.bgStyle} textColor={params.color} text={params.text} />
}

export const ContractorVINStatusChip = memo(ContractorVINStatusChipComponent)
